<template>
  <div class="row">
    <div class="col-sm-6">
      <card v-if="feature">
        <template slot="header">
          <div class="d-flex justify-content-between">
            <h4 class="card-title">{{ feature.name }} Optionen</h4>
          </div>
        </template>
        <div class="row">
          <div class="col-sm-6">
            <form @submit.prevent="addOption">
              <div class="form-group has-label">
                <label>Neue Option</label>
                <div class="input-group">
                  <input class="form-control" v-model="newOptionValue">
                  <div class="input-group-append">
                    <button class="btn btn-fill btn-primary" type="submit" style="margin-bottom: 0;">
                      <i class="fa fa-plus"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div v-if="feature && feature.create_variations">
                <l-checkbox id="nowrap" v-model="ignoreForCreateVariations">Diese Option bei der automatischen Erstellung der Variationen ignorieren</l-checkbox>
              </div>
            </form>
            <ul class="list-group">
              <draggable v-model="feature.options" handle=".handle"
                @end="updateOrder"
              >
                <feature-option v-for="option in feature.options" :key="option.id"
                  :option="option"
                  @saveEdit="updateOption"
                  @deleteOption="deleteOption"
                  :create-variations="feature.create_variations"
                />
              </draggable>
            </ul>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import FeatureOption from './feature-option'

export default {
  components: { FeatureOption, draggable },
  data () {
    return {
      feature: null,
      newOptionValue: null,
      ignoreForCreateVariations: false
    }
  },
  methods: {
    addOption () {
      if (this.newOptionValue) {
        this.$http.post(`/features/${this.feature.id}/options`, {
          value: this.newOptionValue,
          ignore_for_create_variations: this.ignoreForCreateVariations
        }).then(({ data }) => {
          this.feature.options.push(data)
          this.newOptionValue = null
          this.ignoreForCreateVariations = false
        })
      }
    },
    updateOrder () {
      const options = this.feature.options.reduce((options, option, idx) => ({ ...options, [option.id]: idx }), {})
      this.$http.put(`/features/${this.feature.id}/options`, { options })
    },
    updateOption (option) {
      this.$http.put(`/features/${this.feature.id}/options/${option.id}`, option).then(({ data }) => {
        const index = this.feature.options.findIndex(o => o.id === option.id)
        this.feature.options.splice(index, 1, option)
      })
    },
    async deleteOption (option) {
      if (confirm(`Option wirklich löschen?`)) {
        await this.initCsrf()

        this.$http.delete(`/features/${this.feature.id}/options/${option.id}`).then(({ data }) => {
          this.$notify({
            message: `Option erfolgreich gelöscht.`,
            type: 'success'
          })
          const index = this.feature.options.findIndex(({ id }) => data.id === id)
          this.feature.options.splice(index, 1)
        })
      }
    }
  },
  created () {
    this.$http.get(`/features/${this.$route.params.id}`).then(({ data }) => {
      this.feature = data
    })
  }
}
</script>

<style>
  #nowrap label {
    white-space: nowrap;
    text-transform: inherit;
  }
</style>
